import React from 'react';
import {Grid} from "@mui/material";
import EventsCard from "../../../components/Site/eventsCard/EventsCard";

import LazyLoading from "../../../components/Admin/LazyLoading/LazyLoading";
import Loading from "../../../components/Site/Loading/Loading";

import useEvents from "./useEvents";



const Events = () => {
    const queryKey = 'eventList_list';
    const {data: eventList, isLoading, hasNextPage, fetchNextPage} = useEvents(queryKey)

    return (
        <Grid sx={{display: "flex", flexDirection: "column"}}>

            <LazyLoading loadingTxt={'loading...'} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage}
                         maxHeight={'100%'} width={'100%'}>

                {/*{isLoading && <CustomerTabSkeleton/>}*/}
                {isLoading && <Loading/>}
                {
                    eventList?.pages?.map((pageResult, i) => {
                        return (
                            <React.Fragment key={i}>
                                {
                                    pageResult?.result?.map((post, index) =>
                                        <React.Fragment key={index}>
                                            <EventsCard item={post}/>
                                        </React.Fragment>
                                    )
                                }
                            </React.Fragment>
                        )
                    })
                }
            </LazyLoading>

        </Grid>
    );
};

export default Events;